import { BASE_PATH as b, BaseAPI as I, operationServerMap as d } from "../base.js";
import { DUMMY_BASE_URL as B, assertParamExists as h, createRequestFunction as T, serializeDataIfNeeded as v, setSearchParams as g, toPathString as p } from "../common.js";
import m from "axios";
var V = function(a) {
  return {
    merchantTableBillingRuleCreateRule: async (n, t = {}) => {
      h("merchantTableBillingRuleCreateRule", "merchantTableBillingRule", n);
      const i = new URL("/merchant/table/billingRule", B);
      let l;
      a && (l = a.baseOptions);
      const e = {
        method: "POST",
        ...l,
        ...t
      }, r = {}, s = {};
      r["Content-Type"] = "application/json", g(i, s);
      let o = l && l.headers ? l.headers : {};
      return e.headers = {
        ...r,
        ...o,
        ...t.headers
      }, e.data = v(n, e, a), {
        url: p(i),
        options: e
      };
    },
    merchantTableBillingRuleDeleteRule: async (n, t = {}) => {
      h("merchantTableBillingRuleDeleteRule", "tableBillingRuleId", n);
      const i = "/merchant/table/billingRule/{tableBillingRuleId}".replace("{tableBillingRuleId}", encodeURIComponent(String(n))), l = new URL(i, B);
      let e;
      a && (e = a.baseOptions);
      const r = {
        method: "DELETE",
        ...e,
        ...t
      }, s = {};
      g(l, {});
      let o = e && e.headers ? e.headers : {};
      return r.headers = {
        ...s,
        ...o,
        ...t.headers
      }, {
        url: p(l),
        options: r
      };
    },
    merchantTableBillingRuleGetList: async (n, t = {}) => {
      h("merchantTableBillingRuleGetList", "shopId", n);
      const i = "/merchant/table/billingRule/{shopId}".replace("{shopId}", encodeURIComponent(String(n))), l = new URL(i, B);
      let e;
      a && (e = a.baseOptions);
      const r = {
        method: "GET",
        ...e,
        ...t
      }, s = {};
      g(l, {});
      let o = e && e.headers ? e.headers : {};
      return r.headers = {
        ...s,
        ...o,
        ...t.headers
      }, {
        url: p(l),
        options: r
      };
    },
    merchantTableBillingRuleGetListByTableId: async (n, t = {}) => {
      h("merchantTableBillingRuleGetListByTableId", "tableId", n);
      const i = "/merchant/table/billingRule/list_by_table_id/{tableId}".replace("{tableId}", encodeURIComponent(String(n))), l = new URL(i, B);
      let e;
      a && (e = a.baseOptions);
      const r = {
        method: "GET",
        ...e,
        ...t
      }, s = {};
      g(l, {});
      let o = e && e.headers ? e.headers : {};
      return r.headers = {
        ...s,
        ...o,
        ...t.headers
      }, {
        url: p(l),
        options: r
      };
    },
    merchantTableBillingRuleGetTableCategoryList: async (n, t = {}) => {
      h("merchantTableBillingRuleGetTableCategoryList", "tableBillingRuleId", n);
      const i = "/merchant/table/billingRule/tableCategory/{tableBillingRuleId}".replace("{tableBillingRuleId}", encodeURIComponent(String(n))), l = new URL(i, B);
      let e;
      a && (e = a.baseOptions);
      const r = {
        method: "GET",
        ...e,
        ...t
      }, s = {};
      g(l, {});
      let o = e && e.headers ? e.headers : {};
      return r.headers = {
        ...s,
        ...o,
        ...t.headers
      }, {
        url: p(l),
        options: r
      };
    },
    merchantTableBillingRuleUpdateBillingRuleTableCategoryRel: async (n, t, i = {}) => {
      h("merchantTableBillingRuleUpdateBillingRuleTableCategoryRel", "tableBillingRuleId", n), h("merchantTableBillingRuleUpdateBillingRuleTableCategoryRel", "newTableCategoryIds", t);
      const l = "/merchant/table/billingRule/tableCategoryRel/{tableBillingRuleId}".replace("{tableBillingRuleId}", encodeURIComponent(String(n))), e = new URL(l, B);
      let r;
      a && (r = a.baseOptions);
      const s = {
        method: "POST",
        ...r,
        ...i
      }, o = {}, c = {};
      t && (c.newTableCategoryIds = t), g(e, c);
      let u = r && r.headers ? r.headers : {};
      return s.headers = {
        ...o,
        ...u,
        ...i.headers
      }, {
        url: p(e),
        options: s
      };
    },
    merchantTableBillingRuleUpdateRule: async (n, t = {}) => {
      h("merchantTableBillingRuleUpdateRule", "merchantTableBillingRule", n);
      const i = new URL("/merchant/table/billingRule", B);
      let l;
      a && (l = a.baseOptions);
      const e = {
        method: "PUT",
        ...l,
        ...t
      }, r = {}, s = {};
      r["Content-Type"] = "application/json", g(i, s);
      let o = l && l.headers ? l.headers : {};
      return e.headers = {
        ...r,
        ...o,
        ...t.headers
      }, e.data = v(n, e, a), {
        url: p(i),
        options: e
      };
    }
  };
}, R = function(a) {
  const n = V(a);
  return {
    async merchantTableBillingRuleCreateRule(t, i) {
      var l, e;
      const r = await n.merchantTableBillingRuleCreateRule(t, i), s = (l = a == null ? void 0 : a.serverIndex) !== null && l !== void 0 ? l : 0, o = (e = d["MerchantTableBillingRuleApi.merchantTableBillingRuleCreateRule"]) === null || e === void 0 || (e = e[s]) === null || e === void 0 ? void 0 : e.url;
      return (c, u) => T(r, m, b, a)(c, o || u);
    },
    async merchantTableBillingRuleDeleteRule(t, i) {
      var l, e;
      const r = await n.merchantTableBillingRuleDeleteRule(t, i), s = (l = a == null ? void 0 : a.serverIndex) !== null && l !== void 0 ? l : 0, o = (e = d["MerchantTableBillingRuleApi.merchantTableBillingRuleDeleteRule"]) === null || e === void 0 || (e = e[s]) === null || e === void 0 ? void 0 : e.url;
      return (c, u) => T(r, m, b, a)(c, o || u);
    },
    async merchantTableBillingRuleGetList(t, i) {
      var l, e;
      const r = await n.merchantTableBillingRuleGetList(t, i), s = (l = a == null ? void 0 : a.serverIndex) !== null && l !== void 0 ? l : 0, o = (e = d["MerchantTableBillingRuleApi.merchantTableBillingRuleGetList"]) === null || e === void 0 || (e = e[s]) === null || e === void 0 ? void 0 : e.url;
      return (c, u) => T(r, m, b, a)(c, o || u);
    },
    async merchantTableBillingRuleGetListByTableId(t, i) {
      var l, e;
      const r = await n.merchantTableBillingRuleGetListByTableId(t, i), s = (l = a == null ? void 0 : a.serverIndex) !== null && l !== void 0 ? l : 0, o = (e = d["MerchantTableBillingRuleApi.merchantTableBillingRuleGetListByTableId"]) === null || e === void 0 || (e = e[s]) === null || e === void 0 ? void 0 : e.url;
      return (c, u) => T(r, m, b, a)(c, o || u);
    },
    async merchantTableBillingRuleGetTableCategoryList(t, i) {
      var l, e;
      const r = await n.merchantTableBillingRuleGetTableCategoryList(t, i), s = (l = a == null ? void 0 : a.serverIndex) !== null && l !== void 0 ? l : 0, o = (e = d["MerchantTableBillingRuleApi.merchantTableBillingRuleGetTableCategoryList"]) === null || e === void 0 || (e = e[s]) === null || e === void 0 ? void 0 : e.url;
      return (c, u) => T(r, m, b, a)(c, o || u);
    },
    async merchantTableBillingRuleUpdateBillingRuleTableCategoryRel(t, i, l) {
      var e, r;
      const s = await n.merchantTableBillingRuleUpdateBillingRuleTableCategoryRel(t, i, l), o = (e = a == null ? void 0 : a.serverIndex) !== null && e !== void 0 ? e : 0, c = (r = d["MerchantTableBillingRuleApi.merchantTableBillingRuleUpdateBillingRuleTableCategoryRel"]) === null || r === void 0 || (r = r[o]) === null || r === void 0 ? void 0 : r.url;
      return (u, y) => T(s, m, b, a)(u, c || y);
    },
    async merchantTableBillingRuleUpdateRule(t, i) {
      var l, e;
      const r = await n.merchantTableBillingRuleUpdateRule(t, i), s = (l = a == null ? void 0 : a.serverIndex) !== null && l !== void 0 ? l : 0, o = (e = d["MerchantTableBillingRuleApi.merchantTableBillingRuleUpdateRule"]) === null || e === void 0 || (e = e[s]) === null || e === void 0 ? void 0 : e.url;
      return (c, u) => T(r, m, b, a)(c, o || u);
    }
  };
}, L = function(a, n, t) {
  const i = R(a);
  return {
    merchantTableBillingRuleCreateRule(l, e) {
      return i.merchantTableBillingRuleCreateRule(l.merchantTableBillingRule, e).then((r) => r(t, n));
    },
    merchantTableBillingRuleDeleteRule(l, e) {
      return i.merchantTableBillingRuleDeleteRule(l.tableBillingRuleId, e).then((r) => r(t, n));
    },
    merchantTableBillingRuleGetList(l, e) {
      return i.merchantTableBillingRuleGetList(l.shopId, e).then((r) => r(t, n));
    },
    merchantTableBillingRuleGetListByTableId(l, e) {
      return i.merchantTableBillingRuleGetListByTableId(l.tableId, e).then((r) => r(t, n));
    },
    merchantTableBillingRuleGetTableCategoryList(l, e) {
      return i.merchantTableBillingRuleGetTableCategoryList(l.tableBillingRuleId, e).then((r) => r(t, n));
    },
    merchantTableBillingRuleUpdateBillingRuleTableCategoryRel(l, e) {
      return i.merchantTableBillingRuleUpdateBillingRuleTableCategoryRel(l.tableBillingRuleId, l.newTableCategoryIds, e).then((r) => r(t, n));
    },
    merchantTableBillingRuleUpdateRule(l, e) {
      return i.merchantTableBillingRuleUpdateRule(l.merchantTableBillingRule, e).then((r) => r(t, n));
    }
  };
}, S = class extends I {
  merchantTableBillingRuleCreateRule(a, n) {
    return R(this.configuration).merchantTableBillingRuleCreateRule(a.merchantTableBillingRule, n).then((t) => t(this.axios, this.basePath));
  }
  merchantTableBillingRuleDeleteRule(a, n) {
    return R(this.configuration).merchantTableBillingRuleDeleteRule(a.tableBillingRuleId, n).then((t) => t(this.axios, this.basePath));
  }
  merchantTableBillingRuleGetList(a, n) {
    return R(this.configuration).merchantTableBillingRuleGetList(a.shopId, n).then((t) => t(this.axios, this.basePath));
  }
  merchantTableBillingRuleGetListByTableId(a, n) {
    return R(this.configuration).merchantTableBillingRuleGetListByTableId(a.tableId, n).then((t) => t(this.axios, this.basePath));
  }
  merchantTableBillingRuleGetTableCategoryList(a, n) {
    return R(this.configuration).merchantTableBillingRuleGetTableCategoryList(a.tableBillingRuleId, n).then((t) => t(this.axios, this.basePath));
  }
  merchantTableBillingRuleUpdateBillingRuleTableCategoryRel(a, n) {
    return R(this.configuration).merchantTableBillingRuleUpdateBillingRuleTableCategoryRel(a.tableBillingRuleId, a.newTableCategoryIds, n).then((t) => t(this.axios, this.basePath));
  }
  merchantTableBillingRuleUpdateRule(a, n) {
    return R(this.configuration).merchantTableBillingRuleUpdateRule(a.merchantTableBillingRule, n).then((t) => t(this.axios, this.basePath));
  }
};
export {
  S as MerchantTableBillingRuleApi,
  V as MerchantTableBillingRuleApiAxiosParamCreator,
  L as MerchantTableBillingRuleApiFactory,
  R as MerchantTableBillingRuleApiFp
};

//# sourceMappingURL=merchant-table-billing-rule-api.js.map